<template>
  <v-sheet class="d-flex justify-center elevation-4 py-2" v-hotkey="keymap">
    <v-btn
      icon
      large
      @click="onClickPrevious"
      :disabled="buttonPreviousDisabled"
      ><v-icon>mdi-chevron-left</v-icon></v-btn
    >
    <v-btn
      large
      icon
      color="red"
      @click="onClickCancel"
      :disabled="buttonsDisabled"
      ><v-icon>mdi-cancel</v-icon></v-btn
    >
    <v-btn
      icon
      large
      color="green"
      @click="onClickAccept"
      :disabled="buttonsDisabled"
      ><v-icon>mdi-check</v-icon></v-btn
    >
    <v-btn icon large @click="onClickNext" :disabled="buttonNextDisabled"
      ><v-icon>mdi-chevron-right</v-icon></v-btn
    >
    <v-dialog persistent max-width="600" v-model="dialog">
      <v-card>
        <v-card-title>Reject annotation</v-card-title>
        <v-card-text>
          <p class="body-1">Please provide a reason for the rejection.</p>
          <v-textarea v-model="rejectReason"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer /> <v-btn text @click="resetDialog()">Cancel</v-btn>
          <v-btn color="red" text @click="onConfirmReject">Reject</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent max-width="600" v-model="dialogStart">
      <v-card>
        <v-card-text class="text-center pt-5">
          <v-btn large primary @click="onClickStart">Start</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" persistent width="300">
      <v-card>
        <v-card-text class="text-center pt-4">
          <v-progress-circular indeterminate />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import Style from "ol/style/Style";
import { FEATURE_OBSERVATION_ID, FEATURE_STATUS } from "@/constants";
import { setAnnotationStatus } from "@/api/craiyon";

export default {
  props: {
    slide: Object,
    viewer: Object,
    currentSelectedAnnotation: Object
  },
  data() {
    return {
      dialog: false,
      rejectReason: null,
      currentFeatureIndex: -1,
      features: [],
      dialogStart: false,
      loading: false,
      loadingDialog: true
    };
  },
  computed: {
    currentFeature() {
      return this.features[this.currentFeatureIndex];
    },
    currentFeatureStatusIsRejected() {
      if (this.currentFeatureIndex < 0) return false;
      return (
        this.features[this.currentFeatureIndex].get(FEATURE_STATUS) ===
        "rejected"
      );
    },
    currentFeatureStatusIsAccepted() {
      if (this.currentFeatureIndex < 0) return false;
      return (
        this.features[this.currentFeatureIndex].get(FEATURE_STATUS) ===
        "accepted"
      );
    },
    noFeatures() {
      return this.features.length === 0;
    },
    buttonsDisabled() {
      return (
        this.noFeatures ||
        this.currentFeatureStatusIsRejected ||
        this.currentFeatureStatusIsAccepted
      );
    },
    buttonNextDisabled() {
      return (
        this.currentFeatureIndex === this.features.length - 1 || this.noFeatures
      );
    },
    buttonPreviousDisabled() {
      return this.currentFeatureIndex === 0 || this.noFeatures;
    },
    keymap() {
      return {
        s: this.onClickPrevious,
        d: this.onClickNext,
        a: this.onClickAccept,
        x: this.onClickCancel
      };
    }
  },
  watch: {
    viewer: {
      deep: true,
      handler(val) {
        this.features = val.editLayer.getSource().getFeatures();
      }
    }
  },
  methods: {
    resetDialog() {
      this.rejectReason = null;
      this.dialog = false;
    },
    onClickCancel() {
      if (this.buttonsDisabled) return;
      this.dialog = true;
    },
    async onClickAccept() {
      if (this.buttonsDisabled) return;
      console.log("accept");
      // TODO set newStatus to accepted
      await this.setStatus("accepted");
      this.onClickNext();
    },
    async setStatus(status) {
      // this.loadingDialog = true;
      this.loading = true;
      const fhirId = this.currentFeature.get(FEATURE_OBSERVATION_ID); // status id on slide
      const reason = status === "rejected" ? this.rejectReason : undefined;
      await setAnnotationStatus(this.token, status, fhirId, reason);
      // update parent component
      this.currentSelectedAnnotation.status = status;
      this.currentSelectedAnnotation.rejected_reason = reason;
      this.currentFeature.set(FEATURE_STATUS, status);
      this.loading = false;
      // this.loadingDialog = false;
    },
    async onConfirmReject() {
      this.$emit("reject", this.slide);

      await this.setStatus("rejected");
      this.resetDialog();
      // this.viewer.editLayer.getSource().removeFeature(this.currentFeature);
      this.onClickNext();
    },
    onClickPrevious() {
      if (this.buttonPreviousDisabled) return;
      this.hideAllFeatures();
      this.currentFeatureIndex--;
      this.goToFeature();
    },
    goToFeature() {
      // show current feature
      this.showCurrentFeature();
      this.zoomToCurrentFeature();
      this.$emit("annotation:selected", this.currentFeature);
    },
    async onClickNext() {
      if (this.buttonNextDisabled) return;
      this.hideAllFeatures();
      this.currentFeatureIndex++;
      this.goToFeature();
    },
    zoomToCurrentFeature() {
      const extent = this.currentFeature.getGeometry().getExtent();
      this.viewer.map.getView().fit(extent, this.viewer.map.getSize());
      // zoom one level out
      const currentZoom = this.viewer.map.getView().getZoom();
      this.viewer.map.getView().setZoom(currentZoom - 0.5);
    },
    hideAllFeatures() {
      this.features.forEach(e => {
        const style = e.getStyle();
        if (!e.get("style")) {
          e.set("style", style);
        }
        e.setStyle(new Style(null));
      });
    },
    showCurrentFeature() {
      this.currentFeature.setStyle(this.currentFeature.get("style"));
    },
    onClickStart() {
      this.dialogStart = false;
      this.onClickNext();
    },
    start() {
      this.dialogStart = true;
    }
  },
  mounted() {}
};
</script>

<style scoped></style>
